<template>
    <nav class="mb-12">
        <ul class="flex items-center -mr-20">
            <template v-for="(step, index) in steps">
                <li class="relative pr-8 sm:pr-20"
                    v-if="index < currentStep"
                >
                    <!-- Completed Step -->
                    <div class="absolute inset-0 flex items-center">
                        <div class="h-0.5 w-full bg-primary-600"></div>
                    </div>
                    <span class="relative w-8 h-8 flex items-center justify-center bg-primary-600 rounded-full transition ease-in-out duration-150">
                        <!-- Heroicon name: check -->
                        <svg class="w-5 h-5 text-white" viewBox="0 0 20 20" fill="currentColor">
                            <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                        </svg>
                    </span>

                    <div class="absolute -left-10 top-10 w-full text-center text-sm">
                        {{ step.name }}
                    </div>
                </li>

                <li class="relative pr-8 sm:pr-20"
                    v-else-if="index === currentStep"
                >
                    <!-- Current Step -->
                    <div class="absolute inset-0 flex items-center"
                         v-if="index < steps.length"
                    >
                        <div class="h-0.5 w-full bg-gray-200"></div>
                    </div>

                    <span class="relative w-8 h-8 flex items-center justify-center bg-white border-2 border-primary-600 rounded-full">
                            <span class="h-2.5 w-2.5 bg-primary-600 rounded-full"></span>
                        </span>

                    <div class="absolute -left-10 top-10 w-full text-center text-sm">
                        {{ step.name }}
                    </div>
                </li>

                <li class="relative pr-8 sm:pr-20"
                    v-else
                >
                    <!-- Upcoming Step -->
                    <div class="absolute inset-0 flex items-center"
                         v-if="index < steps.length - 1"
                    >
                        <div class="h-0.5 w-full bg-gray-200"></div>
                    </div>
                    <span class="relative w-8 h-8 flex items-center justify-center bg-white border-2 border-gray-300 rounded-full transition ease-in-out duration-150">
                        </span>

                    <div class="absolute -left-10 top-10 w-full text-center text-sm text-gray-400">
                        {{ step.name }}
                    </div>
                </li>
            </template>
        </ul>
    </nav>
</template>

<script>
	export default {
		props: {
		    steps: {
		        type: Array,
                required: true,
            },

            currentStep: {
		        type: Number,
                required: true,
            }
        }
	}
</script>
